export default __webpack_public_path__ + "static/media/profile-banner.a8597d87.jpg";